import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "gallery",
  class: "flex flex-col gap-6 items-center justify-center p-6"
}
const _hoisted_2 = {
  class: "content w-full max-w-screen-lg",
  "data-aos": "slide-up",
  "data-aos-duration": "1000"
}
const _hoisted_3 = { class: "flex gap-4 items-center justify-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex flex-col gap-4" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "flex gap-4 justify-center items-center py-4" }
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "flex gap-4 items-center justify-center" }
const _hoisted_12 = { class: "flex flex-col gap-4" }
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]

import { ref } from "vue";

// Importing photos
import photo1 from "@/assets/img/photo1.jpg";
import photo2 from "@/assets/img/photo2.jpg";
import photo3 from "@/assets/img/photo3.jpg";
import photo4 from "@/assets/img/photo4.jpg";
import photo5 from "@/assets/img/photo5.jpg";
import photo6 from "@/assets/img/photo6.jpg";
import photo7 from "@/assets/img/photo7.jpg";
import photo8 from "@/assets/img/photo8.jpg";


export default /*@__PURE__*/_defineComponent({
  __name: 'PhotoGallery',
  setup(__props) {

const isModalOpen = ref(false);
const currentPhoto = ref<string>("");

function openModal(photoSrc: string) {
  currentPhoto.value = photoSrc;
  isModalOpen.value = true;
  document.body.style.overflow = "hidden"; // Disable scrolling
}

// Close modal
function closeModal() {
  isModalOpen.value = false;
  document.body.style.overflow = ""; // Enable scrolling
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "photo-container bg-gray-200 aspect-square h-[256px] flex items-center justify-center cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openModal(_unref(photo1)))),
          "data-aos": "fade-up",
          "data-aos-delay": "200"
        }, [
          _createElementVNode("img", {
            src: _unref(photo1),
            class: "photo-img",
            alt: "Photo 1"
          }, null, 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: "photo-container bg-gray-200 aspect-square w-[120px] flex items-center justify-center cursor-pointer",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (openModal(_unref(photo2)))),
            "data-aos": "fade-up",
            "data-aos-delay": "400"
          }, [
            _createElementVNode("img", {
              src: _unref(photo2),
              class: "object-cover w-full h-full",
              alt: "Photo 2"
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", {
            class: "photo-container bg-gray-200 aspect-square w-[120px] flex items-center justify-center cursor-pointer",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (openModal(_unref(photo3)))),
            "data-aos": "fade-up",
            "data-aos-delay": "600"
          }, [
            _createElementVNode("img", {
              src: _unref(photo3),
              class: "object-cover w-full h-full",
              alt: "Photo 3"
            }, null, 8, _hoisted_7)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: "photo-container bg-gray-200 aspect-square w-fit flex items-center justify-center cursor-pointer",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (openModal(_unref(photo4)))),
          "data-aos": "fade-up",
          "data-aos-delay": "200"
        }, [
          _createElementVNode("img", {
            src: _unref(photo4),
            class: "object-cover w-full h-full",
            alt: "Photo 4"
          }, null, 8, _hoisted_9)
        ]),
        _createElementVNode("div", {
          class: "photo-container bg-gray-200 aspect-square w-fit flex items-center justify-center cursor-pointer",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (openModal(_unref(photo5)))),
          "data-aos": "fade-up",
          "data-aos-delay": "400"
        }, [
          _createElementVNode("img", {
            src: _unref(photo5),
            class: "object-cover w-full h-full",
            alt: "Photo 5"
          }, null, 8, _hoisted_10)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", {
            class: "photo-container bg-gray-200 aspect-square w-[120px] flex items-center justify-center cursor-pointer",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (openModal(_unref(photo6)))),
            "data-aos": "fade-up",
            "data-aos-delay": "200"
          }, [
            _createElementVNode("img", {
              src: _unref(photo6),
              class: "object-cover w-full h-full",
              alt: "Photo 6"
            }, null, 8, _hoisted_13)
          ]),
          _createElementVNode("div", {
            class: "photo-container bg-gray-200 aspect-square w-[120px] flex items-center justify-center cursor-pointer",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (openModal(_unref(photo7)))),
            "data-aos": "fade-up",
            "data-aos-delay": "400"
          }, [
            _createElementVNode("img", {
              src: _unref(photo7),
              class: "object-cover w-full h-full",
              alt: "Photo 7"
            }, null, 8, _hoisted_14)
          ])
        ]),
        _createElementVNode("div", {
          class: "photo-container bg-gray-200 aspect-square h-[256px] flex items-center justify-center cursor-pointer",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (openModal(_unref(photo8)))),
          "data-aos": "fade-up",
          "data-aos-delay": "600"
        }, [
          _createElementVNode("img", {
            src: _unref(photo8),
            class: "photo-img",
            alt: "Photo 8"
          }, null, 8, _hoisted_15)
        ])
      ])
    ]),
    (isModalOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center overflow-hidden z-50",
          onClick: closeModal
        }, [
          _createElementVNode("div", {
            class: "modal-content",
            onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("img", {
              src: currentPhoto.value,
              alt: "Fullscreen Photo",
              class: "modal-img"
            }, null, 8, _hoisted_16),
            _createElementVNode("button", {
              class: "close-button",
              onClick: _withModifiers(closeModal, ["stop"])
            }, [
              _createVNode(_component_font_awesome_icon, { icon: ['fas', 'times'] })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})